/**
 * @generated SignedSource<<4d17fb187dfc4eb4a233aad773c1df52>>
 * @lightSyntaxTransform
 * @nogrep
 * @codegen-command: yarn relay
 */

/* tslint:disable */
/* eslint-disable */
// @ts-nocheck

import type { ReaderFragment } from 'relay-runtime';
import type { FragmentRefs } from "relay-runtime";
export type threadMessage_AtlassianSearchPage$data = {
  readonly allContributors: ReadonlyArray<{
    readonly email: string | null | undefined;
    readonly extendedProfile: {
      readonly jobTitle: string | null | undefined;
    } | null | undefined;
    readonly externalId: string;
    readonly name: string | null | undefined;
    readonly nickname: string | null | undefined;
    readonly picture: AGG$URL | null | undefined;
  }> | null | undefined;
  readonly entity: {
    readonly createdBy?: {
      readonly linkedUsers: {
        readonly edges: ReadonlyArray<{
          readonly node: {
            readonly name?: string;
            readonly picture?: AGG$URL;
          } | null | undefined;
        } | null | undefined> | null | undefined;
      } | null | undefined;
      readonly thirdPartyUser: {
        readonly email: string | null | undefined;
        readonly extendedProfile: {
          readonly jobTitle: string | null | undefined;
        } | null | undefined;
        readonly externalId: string;
        readonly name: string | null | undefined;
        readonly picture: AGG$URL | null | undefined;
      } | null | undefined;
    } | null | undefined;
  } | null | undefined;
  readonly initialContributors: ReadonlyArray<{
    readonly email: string | null | undefined;
    readonly extendedProfile: {
      readonly jobTitle: string | null | undefined;
    } | null | undefined;
    readonly externalId: string;
    readonly name: string | null | undefined;
    readonly picture: AGG$URL | null | undefined;
  }> | null | undefined;
  readonly integrationId: string | null | undefined;
  readonly " $fragmentSpreads": FragmentRefs<"messageBody_AtlassianSearchPage">;
  readonly " $fragmentType": "threadMessage_AtlassianSearchPage";
};
export type threadMessage_AtlassianSearchPage$key = {
  readonly " $data"?: threadMessage_AtlassianSearchPage$data;
  readonly " $fragmentSpreads": FragmentRefs<"threadMessage_AtlassianSearchPage">;
};

const node: ReaderFragment = (function(){
var v0 = {
  "kind": "ScalarField",
  "name": "name"
},
v1 = {
  "kind": "ScalarField",
  "name": "email"
},
v2 = {
  "kind": "ScalarField",
  "name": "picture"
},
v3 = {
  "kind": "ScalarField",
  "name": "externalId"
},
v4 = {
  "concreteType": "ThirdPartyUserExtendedProfile",
  "kind": "LinkedField",
  "name": "extendedProfile",
  "plural": false,
  "selections": [
    {
      "kind": "ScalarField",
      "name": "jobTitle"
    }
  ]
},
v5 = [
  (v0/*: any*/),
  (v1/*: any*/),
  (v2/*: any*/),
  (v3/*: any*/),
  (v4/*: any*/)
],
v6 = {
  "concreteType": "ThirdPartyUser",
  "kind": "LinkedField",
  "name": "thirdPartyUser",
  "plural": false,
  "selections": (v5/*: any*/)
};
return {
  "argumentDefinitions": [],
  "kind": "Fragment",
  "name": "threadMessage_AtlassianSearchPage",
  "selections": [
    {
      "kind": "FragmentSpread",
      "name": "messageBody_AtlassianSearchPage"
    },
    {
      "kind": "ScalarField",
      "name": "integrationId"
    },
    {
      "kind": "LinkedField",
      "name": "entity",
      "plural": false,
      "selections": [
        {
          "kind": "InlineFragment",
          "selections": [
            {
              "concreteType": "ExternalUser",
              "kind": "LinkedField",
              "name": "createdBy",
              "plural": false,
              "selections": [
                (v6/*: any*/),
                {
                  "concreteType": "GraphStoreSimplifiedUserLinkedThirdPartyUserInverseConnection",
                  "kind": "LinkedField",
                  "name": "linkedUsers",
                  "plural": false,
                  "selections": [
                    {
                      "concreteType": "GraphStoreSimplifiedUserLinkedThirdPartyUserInverseEdge",
                      "kind": "LinkedField",
                      "name": "edges",
                      "plural": true,
                      "selections": [
                        {
                          "kind": "LinkedField",
                          "name": "node",
                          "plural": false,
                          "selections": [
                            {
                              "kind": "InlineFragment",
                              "selections": [
                                (v0/*: any*/),
                                (v2/*: any*/)
                              ],
                              "type": "AtlassianAccountUser"
                            }
                          ]
                        }
                      ]
                    }
                  ]
                }
              ]
            }
          ],
          "type": "ExternalMessage"
        },
        {
          "kind": "InlineFragment",
          "selections": [
            {
              "concreteType": "ExternalUser",
              "kind": "LinkedField",
              "name": "createdBy",
              "plural": false,
              "selections": [
                (v6/*: any*/)
              ]
            }
          ],
          "type": "ExternalComment"
        }
      ]
    },
    {
      "concreteType": "ThirdPartyUser",
      "kind": "LinkedField",
      "name": "initialContributors",
      "plural": true,
      "selections": (v5/*: any*/)
    },
    {
      "concreteType": "ThirdPartyUser",
      "kind": "LinkedField",
      "name": "allContributors",
      "plural": true,
      "selections": [
        (v0/*: any*/),
        {
          "kind": "ScalarField",
          "name": "nickname"
        },
        (v1/*: any*/),
        (v2/*: any*/),
        (v3/*: any*/),
        (v4/*: any*/)
      ]
    }
  ],
  "type": "SearchResultGraphDocument"
};
})();

(node as any).hash = "511ffa5cb72ca70190d1a5c170a7d5b5";

export default node;
